"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  common: {
    green20: '#F4FBE5',
    green100: '#E9F7CC',
    green200: '#BEE666',
    green300: '#A9DD33',
    green400: '#93D500',
    green500: '#76AA00',
    blue20: '#EBEFF1',
    blue50: '#EBEFF1',
    blue100: '#CDD6DC',
    blue200: '#6A8597',
    blue300: '#385D74',
    blue400: '#063451',
    blue500: '#052A41',
    royalBlue100: '#003057',
    purple100: '#E3D0E9',
    purple200: '#AA73BC',
    purple300: '#8E44A5',
    purple400: '#72158F',
    purple500: '#5B1172',
    red20: '#FCE9E9',
    red300: '#E54C4C',
    red400: '#DF1F1F',
    red500: '#B21919',
    orange200: '#FFE2A8',
    orange100: '#FFF2D4',
    grey20: '#F7F7F7',
    grey30: '#EDEDED',
    grey50: '#D6D6D6',
    grey100: '#ADADAD',
    grey200: '#858585',
    grey300: '#5C5C5C',
    grey400: '#333333',
    grey500: '#292929',
    slate: '#767676',
    white: '#FFFFFF',
    black: '#000',
    lightBodyBackground: '#F9F9F9',
    concrete: '#F2F2F2',
    red100_op20: '#f2a5a533'
  },
  primary: {
    light: '#C3E479',
    main: '#93D500',
    // green400
    dark: '#89C602'
  },
  secondary: {
    light01: '#F1E8F4',
    light: '#B88AC7',
    main: '#72158F' // purple400
  },
  warning: {
    main: '#FF3B30'
  },
  text: {
    primary: '#333333',
    // grey400
    secondary: '#353535',
    placeholder: '#858585',
    headingText: '#761594'
  }
};